import { makeStyles } from 'tss-react/mui';

import theme from '@src/theme/theme';

import { dFlex, scrollBar } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  modal: {
    ...dFlex('center', 'flex-start'),
    flexDirection: 'column',
    gap: 24,
    height: '100%',
  },
  headerModal: {
    ...dFlex(),
    gap: 8,
  },
  closeBtn: {
    ...dFlex(),

    '& svg': {
      width: 24,
    },
  },
  children: {
    height: '100%',
    width: '100%',
    marginTop: 'auto',
  },
  dialog: {
    height: 'calc(100% - 40px)',
    top: 'unset',

    '& .MuiDialog-paper': {
      background: theme.palette.custom.background.medium,
      padding: '16px 16px 40px 16px',
      borderRadius: `${theme.borderRadius.xlg} ${theme.borderRadius.xlg} 0px 0px`,
      boxShadow: '0px 1px 60px 0px #0AD9D133',
      border: `1px solid ${theme.palette.custom.border.primary}`,
      ...scrollBar,
    },

    '& .MuiModal-backdrop': {
      background: '#0F0F0FB2',
    },
  },
}));

export default useStyles;
